import React, { forwardRef, useEffect, useImperativeHandle, useRef,  } from 'react';
import Modal from './modal'
import ReactDOM from 'react-dom';

const Container = ({
  visible,
  onClose,
  onOverlayClick,
  content
}, ref) => {
  const container = useRef();

  const handleClose = () => {
    if (container.current) {
      ReactDOM.unmountComponentAtNode(container.current);
      container.current.parentNode.removeChild(container.current);
    }
    container.current = null;
  }

  const render = () => {
    ReactDOM.render(
      <Modal
        onClose={onClose}
        onOverlayClick={onOverlayClick}
        content={content}
      />,
      container.current
    )
  }

  const handleShow = () => {
    container.current = document.createElement('div');
    document.body.appendChild(container.current);
    render()
  }

  useImperativeHandle(ref, () => {
    return {
      refresh() {
        render()
      }
    }
  })

  useEffect(() => {
    if (visible) {
      handleShow();
    } else {
      handleClose()
      // onClose && onClose();
    }
    return () => {
      handleClose();
    }
  }, [visible])

  return null;
}

export default React.memo(forwardRef(Container))



// WEBPACK FOOTER //
// ./src/components/modal-view/index.js